"use strict";
var Country = (function () {
    function Country() {
    }
    return Country;
}());
exports.Country = Country;
//# sourceMappingURL=D:/a/1/s/base/src/models/country.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/country.model.js